module.exports = __webpack_public_path__ + "img/gerdaulogo.6c52a6f7.png";